
function* resendConfirmationCode (action, state) {
  // Code here
}

export default resendConfirmationCode;